import { TranslationObject } from 'ontime-types';

export const langPt: TranslationObject = {
  'common.expected_finish': 'Término esperado',
  'common.minutes': 'min',
  'common.seconds': 'sec',
  'common.now': 'Agora',
  'common.next': 'Próximo',
  'common.scheduled_start': 'Início programado',
  'common.scheduled_end': 'Fim programado',
  'common.expected_start': 'Início previsto',
  'common.expected_end': 'Fim previsto',
  'common.timer_message': 'Mensagem do temporizador',
  'common.secondary_message': 'Mensagem secundária',
  'common.stage_timer': 'Temporizador do presentador',
  'common.started_at': 'Iniciado em',
  'common.time_now': 'Hora atual',
  'common.no_data': 'Sem dados',
  'countdown.skipped': 'Ignorado',
  'countdown.data_error': 'Não foi possível carregar esta vista. Atualize a página.',
  'countdown.no_events_description': 'Adicione eventos no editor e escolha o que pretende mostrar aqui.',
  'countdown.empty_description': 'Escolha os eventos que pretende mostrar aqui.',
  'countdown.choose_events': 'Escolher eventos',
  'countdown.cancel_selection': 'Cancelar',
  'countdown.clear': 'Limpar',
  'countdown.selected': 'selecionados',
  'countdown.group': 'Grupo',
  'countdown.no_title': 'Sem título',
  'countdown.save': 'Guardar',
  'countdown.edit': 'Editar',
  'countdown.ended': 'Evento encerrado às',
  'countdown.running': 'Evento em andamento',
  'countdown.group_running': 'Evento em grupo em andamento',
  'countdown.loaded': 'Evento carregado', //TODO: check translation
  'countdown.select_event': 'Selecione um evento para acompanhar',
  'countdown.to_start': 'Tempo para iniciar',
  'countdown.waiting': 'Aguardando o início do evento',
  'countdown.overtime': 'em tempo extra',
  'countdown.all_have_finished': 'Todos os eventos selecionados terminaram',
  'timeline.live': 'live',
  'timeline.done': 'Concluído',
  'timeline.due': 'Pendente',
  'timeline.followedby': 'Seguido por',
  'timeline.standby': 'Em espera',
  'project.title': 'Título',
  'project.description': 'Descrição',
  'project.info': 'Informações do projeto',
  'project.url': 'URL do projeto',
};
